module.exports = __webpack_public_path__ + "img/end-to-end-visibility-overview-simple-v-2.74aa1e0b.png";